import { AudiencesResult, getAudiencesAdapter } from 'application/adapters/CDP/CDPAdapter';

export type Audiences = {
	audiences: {
		name: string;
		id: string;
	}[];
};

/**
 * Thrown when the audience endpoint answers but the body is not a usable audience result -
 * a 204, an empty body, or a shape without an `audiences` array. Callers must treat this as
 * "we could not find out", never as "the user is in no audiences", or every Exclude rule
 * silently stops applying.
 */
export class AudiencesUnavailableError extends Error {
	constructor(message = 'Audience response did not contain an audiences array') {
		super(message);
		this.name = 'AudiencesUnavailableError';
	}
}

const isAudiencesResult = (value: unknown): value is AudiencesResult =>
	!!value && typeof value === 'object' && Array.isArray((value as { audiences?: unknown }).audiences);

export const getAudiences = async (hostname: string, impersonateId?: string): Promise<AudiencesResult> => {
	const audiences = await getAudiencesAdapter(hostname, impersonateId);

	if (!isAudiencesResult(audiences)) {
		throw new AudiencesUnavailableError();
	}

	return audiences;
};
